<script lang="ts" setup>
defineProps<{
  heading: string;
}>();
</script>

<template>
  <h1
    class="text-text-white mb-6 text-2xl leading-[120%] font-semibold tracking-normal md:mb-8 md:text-5xl"
    style="overflow-wrap: anywhere"
  >
    {{ heading }}
  </h1>
</template>
